export default __webpack_public_path__ + "static/media/BankBalance.c138b56f.png";